// extracted by mini-css-extract-plugin
export default {"dialog":"Dialog_dialog__2JCDs","overlay":"Dialog_overlay__sK5+h","bounce":"Dialog_bounce__svWVv"};